/* Cart drawer: "was removed" + Undo, and Save for later (Wade 2026-09-19). Moved out of snippets/fe-drawer-save-later.liquid
   by Round 1 decision #23 (javascript-10, Wade 2026-10-13) so it is cached instead of re-sent in every page; the snippet
   keeps the styles and loads this file with defer. How it works: see the comment at the top of that snippet. */
  (function () {
    if (window.__feDrawerSaveLater) return;
    window.__feDrawerSaveLater = true;
    var SAVED = 'fe-saved-later';
    var notices = [], busy = false, skipNotice = false;

    function drawer() { return document.getElementById('cart-drawer'); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
    function read() { try { return JSON.parse(localStorage.getItem(SAVED)) || []; } catch (e) { return []; } }
    function write(v) { try { localStorage.setItem(SAVED, JSON.stringify(v)); } catch (e) {} }
    function dataOf(row) {
      try {
        var d = JSON.parse(row.querySelector('.fe-li-data').textContent);
        /* Liquid's json filter prints line item properties as [[name, value], ...] with the text HTML-escaped
           ("J &amp; M"); the cart API wants {name: value} with the shopper's real characters */
        if (Array.isArray(d.properties)) {
          var o = {}, ta = document.createElement('textarea');
          var plain = function (s) { ta.innerHTML = String(s); return ta.value; };
          d.properties.forEach(function (p) { if (p && p[0] != null && p[1] !== '' && p[1] != null) o[plain(p[0])] = plain(p[1]); });
          d.properties = o;
        }
        return d;
      } catch (e) { return null; }
    }
    /* 2026-10-15: not the Perfect Fit Promise rows (snippets/fe-pfp-line.liquid); they leave with their ring */
    function rows() { var d = drawer(); return d ? Array.prototype.slice.call(d.querySelectorAll('line-item-quantity[data-key]:not(.fe-pfp-li-wrap)')) : []; }

    function noticeNode(d) {
      var n = document.createElement('div');
      n.className = 'fe-dremoved';
      n.setAttribute('role', 'status');
      /* one line at any width: the title gives way (CSS ellipsis), "was removed." and Undo never wrap */
      n.innerHTML = '<span><a href="' + esc(d.url) + '">' + esc(d.title) + '</a><i>was removed.</i></span>' +
        '<button type="button" class="fe-dundo">Undo</button>';
      n._d = d;
      return n;
    }

    function place() {
      var d = drawer();
      if (!d) return;
      var live = rows();
      /* a notice whose ring is still in the cart means the change failed: drop it */
      notices = notices.filter(function (n) { return !live.some(function (r) { return r.getAttribute('data-key') === n._d.key; }); });
      var end = d.querySelector('.fe-dremoved-slot');
      notices.forEach(function (n) {
        var anchor = null;
        live.forEach(function (r) { if (!anchor && r.getAttribute('data-key') === n._before) anchor = r; });
        if (anchor) anchor.parentNode.insertBefore(n, anchor);
        else if (end) end.appendChild(n);
      });
      var box = d.querySelector('.fe-dsaved-slot');
      if (!box) return;
      var list = read();
      /* the empty drawer is vertically centered by the theme; with removed lines or saved rings in it the content
         outgrows the panel and slides under the header, so it goes back to a normal top-down scroll */
      var extras = !!d.querySelector('.fe-empty') && (notices.length > 0 || list.length > 0);
      d.classList.toggle('fe-has-extras', extras);
      /* Wade 2026-09-19: empty cart + a saved ring = Move to cart is THE action, so it takes the loud navy and
         Continue shopping steps down to the quiet button (one loud button per view). With rings still in the
         cart, Checkout is the loud one and Move to cart stays quiet. */
      d.classList.toggle('fe-empty-saved', !!d.querySelector('.fe-empty') && list.length > 0);
      if (d.querySelector('.fe-empty')) d.classList.toggle('drawer--center-body', !extras);
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<div class="fe-dsaved"><h3 class="fe-dsaved__h">Saved for later <span>(' + list.length + ')</span></h3>' +
        list.map(function (s, i) {
          var opts = [];
          if (s.variant) String(s.variant).split(' · ').forEach(function (v) { opts.push(v); });
          var props = Array.isArray(s.properties) ? {} : (s.properties || {});
          /* Wade 2026-10-03: same labels as the cart lines - couples sets list Size + Engraving under "His ring" /
             "Her ring" headings, other rings show "Engraving"; the "Add Engraving?: Yes" row is dropped once
             engraving text is shown */
          var fp = props, fhis = [], fher = [];
          var ftext = Object.keys(fp).some(function (k) { return /engrav/i.test(k) && fp[k] && !/^(yes|no)$/i.test(String(fp[k]).trim()); });
          Object.keys(fp).forEach(function (k) {
            var v = fp[k];
            if (k.charAt(0) === '_' || !v) return;
            var eng = /engrav/i.test(k), yn = /^(yes|no)$/i.test(String(v).trim());
            if (eng && yn && ftext) return;
            var m = /^(his|her) /i.exec(k);
            var label = eng && !yn ? 'Engraving' : (m && /size/i.test(k) ? 'Size' : '');
            if (!m) { opts.push((label || k) + ': ' + v); return; }
            (m[1].toLowerCase() === 'his' ? fhis : fher).push((label || k.slice(4)) + ': ' + v);
          });
          /* Wade 2026-10-07: his / her as colour cards, the same markup the Liquid line items render */
          var fgrp = function (h, rows) {
            if (!rows.length) return '';
            var who = /^his/i.test(h) ? 'HIS' : 'HER', size = '', rest = [];
            rows.forEach(function (o) { var m = /^Size:\s*(.+)$/.exec(o); if (m && !size) size = m[1]; else rest.push(o); });
            return '<div class="fe-hh' + (who === 'HER' ? ' fe-hh--her' : '') + '"><div class="fe-hh__head"><span class="fe-hh__chip">' + who + '</span><span>' + (size ? 'Size ' + esc(size) : 'ring') + '</span></div>' +
              (rest.length ? '<ul class="fe-hh__opts">' + rest.map(function (o) { return '<li>' + esc(o) + '</li>'; }).join('') + '</ul>' : '') + '</div>';
          };
          return '<div class="fe-dsaved__item" data-i="' + i + '">' +
            '<a class="fe-dsaved__img" href="' + esc(s.url) + '">' + (s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.title) + '" loading="lazy" width="60" height="60">' : '') + '</a>' +
            '<div class="fe-dsaved__info"><a class="fe-dsaved__t" href="' + esc(s.url) + '">' + esc(s.title) + '</a>' +
            '<div class="fe-dsaved__p">' + esc(s.price) + '</div>' +
            (opts.length ? '<ul class="fe-li__opts">' + opts.map(function (o) { return '<li>' + esc(o) + '</li>'; }).join('') + '</ul>' : '') + fgrp('His ring', fhis) + fgrp('Her ring', fher) +
            (s.pfp ? '<ul class="fe-li__opts"><li>With the Perfect Fit Promise</li></ul>' : '') +
            '<div class="fe-dsaved__msg" role="alert" hidden></div>' +
            '<div class="fe-li__actions"><button type="button" class="fe-dsaved__move">Move to cart</button>' +
            '<button type="button" class="fe-dsaved__del fe-li__later" style="color:var(--fe-faint)" aria-label="Remove ' + esc(s.title) + ' from saved for later">Remove</button></div>' +
            '</div></div>';
        }).join('') + '</div>';
    }

    /* add the ring back, then hand the theme a normal cart:change (with its bundled sections) */
    function add(d) {
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      return fetch(root + 'cart/add.js', { method: 'POST', headers: json,
        /* 2026-10-15: a ring that had the Perfect Fit Promise gets it back, nested under it again */
        body: JSON.stringify({ items: [{ id: d.id, quantity: d.quantity || 1, properties: d.properties || {} }]
          .concat(d.pfp ? [{ id: d.pfp, quantity: d.quantity || 1, parent_id: d.id }] : []) })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'This ring is no longer available.'); });
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
        return fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ sections: sections.join(',') }) });
      }).then(function (r) { return r.json(); });
    }
    function announce(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } }));
    }

    document.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || !d.contains(e.target)) return;
      var t = e.target.closest('.fe-li__remove, .quantity-selector__button[href$="quantity=0"], .fe-li__later, .fe-dundo, .fe-dsaved__move');
      if (!t) return;

      if (t.matches('.fe-li__remove, .quantity-selector__button')) {
        /* the theme performs the removal (Remove, or minus at quantity 1); this only remembers what stood here */
        var row = t.closest('line-item-quantity[data-key]');
        var data = row && dataOf(row);
        if (data && !skipNotice) {
          var n = noticeNode(data), all = rows(), next = all[all.indexOf(row) + 1];
          n._before = next ? next.getAttribute('data-key') : null;
          notices.push(n);
        }
        skipNotice = false;
        return;
      }
      e.preventDefault();

      if (t.classList.contains('fe-dsaved__del')) {
        var l = read();
        l.splice(+t.closest('.fe-dsaved__item').getAttribute('data-i'), 1);
        write(l);
        place();
        return;
      }
      if (t.classList.contains('fe-li__later')) {
        var r2 = t.closest('line-item-quantity[data-key]');
        var d2 = r2 && dataOf(r2);
        if (!d2) return;
        var saved = read().filter(function (s) { return s.key !== d2.key; });
        saved.unshift(d2);
        write(saved.slice(0, 20));
        skipNotice = true;
        t.style.opacity = '0.4';
        r2.querySelector('.fe-li__remove').click();
        return;
      }

      if (busy) return;
      busy = true;
      t.style.opacity = '0.4';
      var undo = t.classList.contains('fe-dundo');
      var holder = undo ? t.closest('.fe-dremoved') : t.closest('.fe-dsaved__item');
      var list = read();
      var item = undo ? holder._d : list[+holder.getAttribute('data-i')];
      add(item).then(function (cart) {
        /* settle the books BEFORE the theme redraws the drawer (its redraw can finish within the same tick) */
        if (undo) { notices = notices.filter(function (n) { return n !== holder; }); holder.remove(); }
        else { list.splice(+holder.getAttribute('data-i'), 1); write(list); }
        busy = false;
        announce(cart);
      }).catch(function (err) {
        busy = false;
        t.style.opacity = '';
        var m = undo ? holder.querySelector('span') : holder.querySelector('.fe-dsaved__msg');
        if (m) { m.hidden = false; m.style.display = 'block'; m.style.whiteSpace = 'normal'; m.textContent = err.message; }
      });
    }, true);

    /* When the drawer empties, the theme fades its pinned footer out (opacity 0, 30px down) and only ever fades it back in
       when the drawer OPENS. Undo / Move to cart refill a drawer that is already open - a path the stock theme never
       takes - so the footer (Checkout, express checkout, the whole sticky bar) stayed invisible. Bring it back here. */
    function wakeFooter() {
      var d = drawer();
      var foot = d && d.shadowRoot && d.shadowRoot.querySelector('[part="footer"]');
      if (!foot || d.querySelector('.fe-empty') || !d.hasAttribute('open')) return;
      if (getComputedStyle(foot).opacity === '1' && foot.style.transform.indexOf('30px') === -1) return;
      if (foot.getAnimations) foot.getAnimations().forEach(function (a) { a.cancel(); });
      foot.style.opacity = '1';
      foot.style.transform = 'translateY(0px)';
      if (foot.animate) foot.animate({ opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0px)'] }, { duration: 250, easing: 'cubic-bezier(.25,.46,.45,.94)' });
    }
    document.addEventListener('cart-drawer:refreshed', function () { place(); wakeFooter(); });
    /* the saved list can change on the cart page or in another tab: refresh it whenever the drawer opens */
    function bind() { var d = drawer(); if (d) d.addEventListener('dialog:before-show', place); place(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  })();
